// Cancellation Policy Spanish Strings

export const STRINGS = {
  // Basic Messages
  FREE_CANCELLATION_AVAILABLE: "Cancelación gratuita disponible",
  NON_REFUNDABLE: "No reembolsable",
  CUSTOM_CANCELLATION_POLICY: "Política de cancelación personalizada",
  CANCELLATION_UNAVAILABLE: "Detalles de la política de cancelación no disponibles",
  CUSTOM_CANCELLATION_UNAVAILABLE: "Detalles de la política de cancelación personalizada no disponibles",

  // UI Elements
  CANCELLATION_POLICY_TITLE: "Política de Cancelación",

  // Weather and Traveler Conditions
  BAD_WEATHER_POLICY: "Esta experiencia requiere buen clima. Si se cancela debido al mal tiempo, se le ofrecerá una fecha diferente o un reembolso completo.",
  MINIMUM_TRAVELERS_POLICY: "Esta experiencia requiere un número mínimo de viajeros. Si se cancela porque no se alcanza el mínimo, se le ofrecerá una fecha/experiencia diferente o un reembolso completo.",
  
  // Detailed Policy Messages
  CANCELLATION_POLICY_DETAILS: "Detalles de la Política de Cancelación:",
  CUTOFF_TIMES_LOCAL: "Las horas límite se basan en la hora local de la experiencia."
};

// Template strings that require formatting
export const FORMATTED_STRINGS = {
  FREE_CANCELLATION_DAYS_BEFORE: "Cancelación gratuita si se cancela al menos {days} día{plural} antes.",
  FREE_CANCELLATION_DAYS_BEFORE_SELECTED_DATE: "Cancelación gratuita si se cancela al menos {days} día{plural} antes de la fecha seleccionada",
  CANCEL_UP_TO_DAYS: "Puede cancelar hasta {days} día{plural} antes de la experiencia para un reembolso completo.",
  NO_REFUND_LESS_THAN_DAYS: "Si cancela menos de {days} día{plural} antes de la hora de inicio de la experiencia, el monto pagado no será reembolsado.",
  NO_CHANGES_LESS_THAN_DAYS: "No se aceptarán cambios realizados menos de {days} día{plural} antes de la hora de inicio de la experiencia."
};

/**
 * Helper function to format strings with day count and proper pluralization
 * @param template The template string with {days} and {plural} placeholders
 * @param days The number of days
 * @returns Formatted string with proper pluralization
 */
export const formatDaysString = (template: string, days: number): string => {
  const plural = days > 1 ? 's' : '';
  return template.replace('{days}', days.toString()).replace('{plural}', plural);
}; 